import React, { Fragment } from "react"
import './blog.scss'
import ReactHtmlParser from 'react-html-parser'
import { Link } from 'react-router-dom'
import Button from '../../components/newButton/button'

// import { Link } from 'react-router-dom'
import { Post } from '../../queries/blog'
import Back from '../../components/backButton/backButton'
// import dayjs from 'dayjs'

import Navbar from '../../components/newNavbar/navbar'
// import Button from '../../components/newButton/newButton'
import Loading from '../../components/loading/loading'
// import ButtonText from '../../components/buttonText/buttonText'
import { Query } from 'react-apollo'
import ErrorBroundray from '../../components/errorBoundary/errorBoundary'
import Footer from '../../components/newFooter/footer'


export default class BlogPost extends React.Component {


    render() {
        return (
            <Fragment>
                <div className="col-xs-12" style={{ marginLeft: "0", paddingLeft: "0" }}>
                    <ErrorBroundray><Navbar /></ErrorBroundray>
                    <div className="blogPost row">
                        <Query query={Post} variables={{ id: window.location.pathname.split('/')[(window.location.pathname.split('/').length - 1)] }}>
                            {res => {
                                if (res.loading) return <Loading />
                                if (res.error) return <p>Algo de errado aconteceu. Tente novamente.</p>
                                if (res.data.allPosts) {
                                    const post = res.data.allPosts[0]
                                    return <div className="post col-xs-12">
                                        <div className="contentHTML">{post ? ReactHtmlParser(post.content) : <div style={{ textAlign: 'center', width: '100vw' }}>Post não encontrado</div>}</div>
                                        {/* <p className="date">Publicado em: {dayjs(post.updated).format("DD/MM/YYYY")}</p> */}
                                    </div>
                                } else {
                                    return <p>erro</p>
                                }
                            }}
                        </Query>
                        {/* <div className="post">
                        <div className="contentHTML">
                            
                        </div>
                    </div> */}
                    
                        
                        <div className="col-xs-12">
                            <Back />
                        </div>
                        <div className="col-xs-12 row" style={{ color: "#5f5f5f", marginTop: "10px", marginBottom: "10px" }}>
                            <div className="col-xs-12">
                                <h3>Venha fazer parte da Oito.</h3>
                                </div> 
                                <div className="col-xs-12">
                                   <Link to='/cadastro'><Button name='Cadastre-se!' /></Link> 
                                </div>
                                
                        </div>
                    </div>
                    
                </div>
                <ErrorBroundray><Footer/></ErrorBroundray>
            </Fragment>
        )
    }
}